import Joi from 'joi';
import blockAppearanceSchema from '@utils/validate/blocksSchemes/blockAppearanceSchema';
import linkSchema from '@utils/validate/blocksSchemes/linkSchema';
import imageWithMetaDataSchema from '@utils/validate/blocksSchemes/imageWithMetadataSchema';
const CategoryLogoCarousel = Joi.object({
  type: Joi.string().valid('categoryLogoCarousel').required(),
  code: Joi.string().allow('', null).required(),
  title: Joi.string().allow('', null),
  logos: Joi.array().items(Joi.object({
    icon: Joi.string().allow('', null).required(),
    id: Joi.number().required(),
    itemId: Joi.string().allow('', null),
    link: linkSchema.allow('', null).required(),
    svg: Joi.object(imageWithMetaDataSchema).allow('', null)
  }).unknown(true)),
  ...blockAppearanceSchema
}).unknown(true);
export default CategoryLogoCarousel;